import * as React from "react";

interface IComponentProps {
	/**
	 * Is ascending flag.
	 */
	isAsc: boolean
}

export default class TableOrderIndicator extends React.Component<IComponentProps, {}> {
	render() {
		return (
			<span key={`${this.props.isAsc}`}>
				{this.props.isAsc ? <i className={"fa fa-fw fa-caret-up"}/> : <i className={"fa fa-fw fa-caret-down"}/>}
			</span>
		);
	}
}